exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.loading[data-v-fbb2b198] {\n  text-align: center;\n}\n.loading i[data-v-fbb2b198] {\n    font-size: 48px;\n}\n.recomendation[data-v-fbb2b198] {\n  float: none;\n  display: inline-block;\n}\n.recomendations[data-v-fbb2b198] {\n  text-align: center;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fbb2b198","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Search/SearchLinks.vue
// module id = 679
// module chunks = 3